import { createFileRoute, redirect } from "@tanstack/react-router";

/** The old pack payments page now lives in Finances, where everything owed is listed together. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders, so the crumb comes from the layout route
export const Route = createFileRoute("/(private)/payments/")({
  beforeLoad: () => {
    throw redirect({ to: "/finances/payments", search: { tab: "to-collect" } });
  },
});
